module.exports = __webpack_public_path__ + "fonts/Gilroy-ExtraBold.bdf3ea41.eot";